import { useMemo } from 'react'

import {
  CreateScrapeTemplateMutation,
  CreateScrapeTemplateMutationVariables,
  DeleteScrapeTemplateMutation,
  DeleteScrapeTemplateMutationVariables,
  ScrapeTemplateQuery,
  ScrapeTemplateQueryVariables,
  ScrapeTemplatesQuery,
  ScrapeTemplatesQueryVariables,
  UpdateScrapeTemplateMutation,
  UpdateScrapeTemplateMutationVariables,
} from 'types/graphql'

import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const GetAll = gql`
  query ScrapeTemplatesQuery($organizationId: Int!) {
    scrapeTemplates(organizationId: $organizationId) {
      ...ScrapeTemplateFragment
    }
  }
`
export const useScrapeTemplatesQuery = () => {
  const organizationId = useMyOrgId()
  const { data, ...rest } = useQuery<ScrapeTemplatesQuery, ScrapeTemplatesQueryVariables>({
    queryKey: [QueryKey.ScrapeTemplates, organizationId],
    queryDocument: GetAll,
    variables: { organizationId: organizationId ?? -1 },
    enabled: !!organizationId,
  })
  const scrapeTemplates = useMemo(() => data?.scrapeTemplates || [], [data])
  return { ...rest, scrapeTemplates }
}

const GetOne = gql`
  query ScrapeTemplateQuery($id: Int!) {
    scrapeTemplate(id: $id) {
      ...ScrapeTemplateFragment
    }
  }
`
export const useScrapeTemplateQuery = (id: number) => {
  const { data, ...rest } = useQuery<ScrapeTemplateQuery, ScrapeTemplateQueryVariables>({
    queryKey: [QueryKey.ScrapeTemplate, id],
    queryDocument: GetOne,
    variables: { id },
  })
  const scrapeTemplate = data?.scrapeTemplate
  return { ...rest, scrapeTemplate }
}

const Create = gql`
  mutation CreateScrapeTemplateMutation($input: ScrapeTemplateInput!) {
    createScrapeTemplate(input: $input) {
      ...ScrapeTemplateFragment
    }
  }
`
export const useCreateScrapeTemplateMutation = () => {
  return useMutation<CreateScrapeTemplateMutation, CreateScrapeTemplateMutationVariables>({
    mutationDocument: Create,
  })
}

const Update = gql`
  mutation UpdateScrapeTemplateMutation($id: Int!, $input: ScrapeTemplateInput!) {
    updateScrapeTemplate(id: $id, input: $input) {
      ...ScrapeTemplateFragment
    }
  }
`
export const useUpdateScrapeTemplateMutation = () => {
  return useMutation<UpdateScrapeTemplateMutation, UpdateScrapeTemplateMutationVariables>({
    mutationDocument: Update,
  })
}

const Delete = gql`
  mutation DeleteScrapeTemplateMutation($id: Int!) {
    deleteScrapeTemplate(id: $id) {
      id
    }
  }
`
export const useDeleteScrapeTemplateMutation = () => {
  return useMutation<DeleteScrapeTemplateMutation, DeleteScrapeTemplateMutationVariables>({
    mutationDocument: Delete,
  })
}
